export default __webpack_public_path__ + "static/media/vid.7e116622.mp4";